export default {
  navigationBarTitleText: '修改意见'
};
